<p-panel [toggleable]="false" styleClass="shadow-sm dark:bg-gray-800">
    <ng-template pTemplate="header">
        <div class="flex items-center gap-2 px-2 sm:px-0">
            <i class="fas fa-paperclip text-primary text-lg sm:text-base"></i>
            <span class="font-medium text-base sm:text-sm"
                >{{ 'common.attachments' | translate }}</span
            >
            <span class="text-sm text-muted-foreground"
                >({{ assetsResource.value()?.length || 0 }})</span
            >
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="space-y-2">
            @if (assetsResource.isLoading()) {
            <div class="flex items-center justify-center py-6 sm:py-4 px-2">
                <i class="fas fa-spinner fa-spin text-primary text-lg sm:text-base"></i>
                <span class="ml-2 text-sm sm:text-base">{{ 'common.loading' | translate }}</span>
            </div>
            } @else if (assetsResource.hasValue() && assetsResource.value()?.length) {
            <div class="grid gap-2 px-2 sm:px-0">
                @for (asset of assetsResource.value(); track asset.id) {
                <div
                    class="flex items-center justify-between p-3 sm:p-3 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors cursor-pointer active:bg-gray-200 dark:active:bg-gray-500 min-h-[3.5rem] sm:min-h-[3rem]"
                    (click)="downloadAssets(asset.id)"
                >
                    <div class="flex items-center gap-3 flex-1 min-w-0">
                        <div class="flex-shrink-0">
                            @if (isImageFileByExtension(asset.name)) {
                            <i class="fas fa-image text-blue-500 text-lg sm:text-base"></i>
                            } @else if (asset.mimeType?.includes('pdf')) {
                            <i class="fas fa-file-pdf text-red-500 text-lg sm:text-base"></i>
                            } @else if (asset.mimeType?.includes('word') ||
                            asset.mimeType?.includes('document')) {
                            <i class="fas fa-file-word text-blue-600 text-lg sm:text-base"></i>
                            } @else {
                            <i class="fas fa-file text-gray-500 text-lg sm:text-base"></i>
                            }
                        </div>
                        <div class="flex-1 min-w-0">
                            <div
                                class="font-medium text-sm sm:text-sm truncate"
                                [title]="asset.displayName || asset.name"
                            >
                                {{ asset.displayName || asset.name }}
                            </div>
                            @if (asset.fileSize) {
                            <div class="text-xs text-muted-foreground">
                                {{ asset.fileSize | number }} bytes
                            </div>
                            }
                        </div>
                    </div>
                    <div class="flex items-center gap-2">
                        <span class="text-xs text-muted-foreground uppercase hidden sm:inline">
                            {{ asset.mimeType?.split('/')[1] || 'file' }}
                        </span>
                        <i
                            class="fas fa-download text-primary hover:text-primary-dark transition-colors text-lg sm:text-base"
                        ></i>
                    </div>
                </div>
                }
            </div>
            } @else {
            <div class="text-center py-6 sm:py-8 text-muted-foreground px-2">
                <i class="fas fa-paperclip text-2xl sm:text-3xl mb-2 opacity-50"></i>
                <p class="text-sm sm:text-base">
                    {{ 'common.no-attachments-available' | translate }}
                </p>
            </div>
            }
        </div>
    </ng-template>
</p-panel>
